<template>
  <div>
    <loading v-show="showLoader"/>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'ComplaintFeedback' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Complaint</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <form class="form-group" v-on:submit="createComplaint" id="createComplaint" style="width: 100%; position: relative; overflow-x: hidden;">
        <div class="container multistep-box">
          <div class="row mb-4">
            <div class="col-12 ib-border-b" >
              <ul class="list-inline">
                <li><h1 class="ib-claim-listing">Add Complaints</h1></li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label class="jbl-dynamic-label">Complaint Subject</label>
              <div class="jbl-field">
                <input class="jbl-dynamic-input" type="text" name="complain_subject" placeholder="Complaint Subject" v-model="subject"/>
              </div>
            </div>

            <div class="col-md-6 px-3 px-sm-3">
              <div>
                <div class="ib-dropdown-error">
                  <div>
                    <label>Select Complaint Type</label>
                    <select style="width: 100% !important;" class="floating-select" name="type" @change="checkComplaintType()" v-model="type" onclick="this.setAttribute('value', this.value);">
                      <option value="">Select Complaint Type</option>
                      <option value="policy">Policy Complaint</option>
                      <option value="claim">Claim Complaint</option>
                      <option value="general">General Queries</option>
                      <option value="idea">Share Your Idea</option>
                    </select>
                    <span class="highlight"></span>
                    <div class="ib-custom-select"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6" v-if="selectedPolicyId != ''">
              <div class="jbl-card-width">
                <div class="row data-row-item w-100">
                  <div class="">
                    <img class="claim-product-img in-min-width" :src="selfPolicies.filter(x => x.id == selectedPolicyId)[0].product_image">
                  </div>
                  <div class="pl-1">
                    <h2 class="claim-product-heading">{{ selfPolicies.filter(x => x.id == selectedPolicyId)[0].product_name }}</h2>
                    <p class="claim-product-text"><span class="secondary-color">Policy No: </span>{{ selfPolicies.filter(x => x.id == selectedPolicyId)[0].policy_no}}</p>
                  </div>
                </div>
                <div class="w-100 jbl-plc-change">
                  <div>
                    <a class="float-right ib-edit-btn edit-btn-position"  @click="showPoliciesModal = true"><i class="fa fa-edit"></i></a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6" v-if="selectedClaimId != '' && selectedClaimType == 'self'">
              <div class="jbl-card-width">
                <div class="row data-row-item w-100">
                  <div class="">
                    <img class="claim-product-img in-min-width" :src="self_claims.filter(x => x.id == selectedClaimId)[0].product_image">
                  </div>
                  <div class="pl-1">
                    <h2 class="claim-product-heading" style="margin-bottom:.9rem;">{{ self_claims.filter(x => x.id == selectedClaimId)[0].product_name }}</h2>
                    <p class="claim-product-text" style="margin-bottom:.2rem;"><span class="secondary-color">Policy No: </span>{{ self_claims.filter(x => x.id == selectedClaimId)[0].policy_no}}</p>
                    <p class="claim-product-text"><span class="secondary-color">Claim No: </span>{{ self_claims.filter(x => x.id == selectedClaimId)[0].claim_no}}</p>
                  </div>
                </div>
                <div class="w-100 jbl-plc-change">
                  <div>
                      <a class="float-right ib-edit-btn edit-btn-position" @click="showClaimsModal = true"><i class="fa fa-edit"></i></a>
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-6" v-if="selectedClaimId != '' && selectedClaimType == 'nominated'">
              <div class="jbl-card-width">
                <div class="row data-row-item w-100">
                  <div class="">
                    <img class="claim-product-img" :src="nominated_claims.filter(x => x.id == selectedClaimId)[0].product_image" style="width: 115px;">
                  </div>
                  <div class="pl-1">
                    <h2 class="claim-product-heading" style="margin-bottom:.9rem;">{{ nominated_claims.filter(x => x.id == selectedClaimId)[0].product_name }}</h2>
                    <p class="claim-product-text" style="margin-bottom:.2rem;"><span class="secondary-color">Policy No: </span>{{ nominated_claims.filter(x => x.id == selectedClaimId)[0].policy_no}}</p>
                    <p class="claim-product-text"><span class="secondary-color">Claim No: </span>{{ nominated_claims.filter(x => x.id == selectedClaimId)[0].claim_no}}</p>
                  </div>
                </div>
                <div class="w-100 jbl-plc-change">
                    <span class="float-right" @click="showClaimsModal = true">
                        <img class="img-fluid" :src="require('@/assets/images/jbl-profile-edit.png')" alt="edit icon">
                    </span>
                  </div>
              </div>
            </div>

            <div class="col-md-6">
              <label class="jbl-dynamic-label">Description</label>
              <div class="jbl-field">
                <textarea type="text" class="jbl-dynamic-input" placeholder="Enter Description" name="description" v-model="description"></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="ib-action-btns">
                <button type="submit" class="ib-btn-primary ib-btn-width ib-btn-hover mr-3">Submit</button>
                <router-link class="btn ib-btn-outline ib-btn-width ib-btn-hover" :to="{ name: 'ComplaintFeedback' }">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div v-if="showPoliciesModal">
      <transition name="modal fade">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
              <div class="modal-content">
                <div class="jbl-m-inner">
                  <div class="modal-header ib-modal-header">
                    <h3 class="compare-th-title">Select Policy</h3>
                    <span class="ib-m-close ib-x-m-icon" data-dismiss="modal" aria-label="Close">
                    <img @click="showPoliciesModal = false" aria-hidden="true" class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                    </span>
                    <hr class="ib-dotted-hr" style="width:100% !important; margin-bottom:0rem !important;">
                  </div>
                  <div class="modal-body jbl-modal-body">
                    <div class="jbl-card-width">
                      <button class="row data-row-item w-100" v-for="policy in selfPolicies" v-on:click="selectPolicy(policy.id)">
                        <div class="">
                          <img class="claim-product-img" :src="policy.product_image" style="width: 115px;">
                        </div>
                        <div class="pl-1">
                          <h2 class="claim-product-heading">{{ policy.product_name }}</h2>
                          <p class="claim-product-text"><span class="secondary-color">Policy No: </span>{{ policy.policy_no }}</p>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showClaimsModal">
      <transition name="modal fade">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
              <div class="modal-content">
                <div class="jbl-m-inner">
                  <div class="modal-header ib-modal-header">
                    <h3 class="compare-th-title">Select Claim</h3>
                    <span class="ib-m-close ib-x-m-icon" data-dismiss="modal" aria-label="Close">
                    <img @click="showClaimsModal = false" aria-hidden="true" class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                    </span>
                  </div>
                  <div class="modal-body jbl-modal-body">
                    <div class="jbl-card-width">
<!--                      <span class="claim_modal_type_heading">Self Claims</span>-->
                      <hr class="ib-dotted-hr" style="width:100% !important;">
                      <button class="row data-row-item w-100" v-for="sf_claim in self_claims" v-on:click="selectClaim(sf_claim.id, 'self')">
                        <div class="">
                          <img class="claim-product-img" :src="sf_claim.product_image" style="width: 115px;">
                        </div>
                        <div class="pl-1">
                          <h2 class="claim-product-heading" style="margin-bottom:.9rem;">{{ sf_claim.product_name }}</h2>
                          <p class="claim-product-text" style="margin-bottom:.2rem;"><span class="secondary-color">Policy No: </span>{{ sf_claim.policy_no }}</p>
                          <p class="claim-product-text"><span class="secondary-color">Claim No: </span>{{ sf_claim.claim_no }}</p>
                        </div>
                      </button>
<!--                      <span class="claim_modal_type_heading">Nominated Claims</span>-->
<!--                      <hr class="ib-dotted-hr" style="width:100% !important;">-->
<!--                      <button class="row data-row-item w-100" v-for="nm_claim in nominated_claims" v-on:click="selectClaim(nm_claim.id, 'nominated')">-->
<!--                        <div class="">-->
<!--                          <img class="claim-product-img" :src="nm_claim.product_image" style="width: 115px;">-->
<!--                        </div>-->
<!--                        <div class="pl-1">-->
<!--                          <h2 class="claim-product-heading" style="margin-bottom:.9rem;">{{ nm_claim.product_name }}</h2>-->
<!--                          <p class="claim-product-text" style="margin-bottom:.2rem;"><span class="secondary-color">Policy No: </span>{{ nm_claim.policy_no }}</p>-->
<!--                          <p class="claim-product-text"><span class="secondary-color">Claim No: </span>{{ nm_claim.claim_no }}</p>-->
<!--                        </div>-->
<!--                      </button>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import loading from "@/components/Loading/Loading";

  export default {
    name: 'ComplaintCreate',
    components: {
      loading
    },
    data () {
      return {
        showLoader: false,
        selfPolicies: [],
        subject: '',
        type: '',
        description: '',
        showPoliciesModal: false,
        selectedPolicyId: '',
        self_claims: [],
        nominated_claims: [],
        selectedClaimId: '',
        selectedClaimType: '',
        showClaimsModal: false
      };
    },
    created: function () {
      const self = this;
      self.getData();
    },
    methods: {
      async getData () {
        const self = this;
        const promises = [];

        self.showLoader = true;
        promises.push(await axios.get('customer/customer_policies_listing?status=active').then(function (resp) {
          if (resp.data.code == 200) {
            self.selfPolicies = resp.data.data.policies.filter(x => x.policy_no != null);
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        promises.push(await axios.get('customer/claims').then(function (resp) {
          if (resp.data.code == 200) {
            self.self_claims = resp.data.data.self_policies_claims;
            self.nominated_claims = resp.data.data.nominated_policies_claims;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      checkComplaintType () {
        const self = this;
        self.selectedPolicyId = '';
        self.selectedClaimId = '';
        self.selectedClaimType = '';
        if(self.type == 'policy') {
          if (self.selfPolicies.length < 1) {
            $toast.error('No Policies Available.', { position: 'top-right' });
            self.showPoliciesModal = false;
            self.showClaimsModal = false;
            return false;
          } else {
            self.showPoliciesModal = true;
          }
        } else if (self.type == 'claim') {
          if (self.self_claims.length < 1 && self.nominated_claims < 1) {
            $toast.error('No Claim Available.', { position: 'top-right' });
            self.showPoliciesModal = false;
            self.showClaimsModal = false;
            return false;
          } else {
            self.showClaimsModal = true;
          }
        } else {
          self.showPoliciesModal = false;
          self.showClaimsModal = false;
        }
      },
      selectPolicy(id) {
        const self = this;
        self.selectedPolicyId = id;
        self.showPoliciesModal = false;
      },
      selectClaim(id, type) {
        const self = this;
        self.selectedClaimId = id;
        self.selectedClaimType = type;
        self.showClaimsModal = false;
      },
      async createComplaint(e) {
        const self = this;
        e.preventDefault();

        if(self.subject == '') {
          $toast.error('Add subject', { position: 'top-right' });
          return false;
        }
        if(self.type == '') {
          $toast.error('Select complaint type', { position: 'top-right' });
          return false;
        }
        if(self.description == '') {
          $toast.error('Add description', { position: 'top-right' });
          return false;
        }
        if(self.type == 'policy' && self.selectedPolicyId == '') {
          self.type = '';
          $toast.error('Select policy', { position: 'top-right' });
          return false;
        }
        if(self.type == 'claim' && self.selectedClaimId == '') {
          self.type = '';
          $toast.error('Select claim', { position: 'top-right' });
          return false;
        }

        var formData = new FormData();
        formData.append('type', self.type);
        formData.append('description', self.description);
        formData.append('complain_subject', self.subject);
        if(self.selectedPolicyId != '') {
          formData.append('customer_quotation_id', self.selectedPolicyId);
        }

        if(self.selectedClaimId != '') {
          formData.append('claim_id', self.selectedClaimId);
        }

        self.showLoader = true;
        await axios.post("customer/complains/create", formData).then(function(resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            $toast.success(resp.data.message, { position: 'top-right' });
            self.$router.push({ name: 'ComplaintFeedback' });
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    }
  };
</script>

<style scoped>
  .data-row p {
    color: #5b6770;
  }
  table > tbody > tr,
  .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Avenir Medium";
  }
  .data-row .claim-row-data {
    font-family: "Avenir Medium";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img,
  .data-row .data-img {
    padding: 14.7px 12.6px 14.7px 13px;
    border-radius: 10px;
    background-color: #ba0c2f;
  }
  table > tbody > tr > th > img,
  .data-row .data-img img {
    padding: 3.4px 14.2px 8.1px 14.2px;
  }
  .input-placeholder:focus ~ label,
  .input-placeholder:valid ~ label {
    font-size: 11px;
    left: 10px;
    top: -10px;
  }
  .input-placeholder:valid ~ label {
    color: green;
  }
  .input-placeholder:focus:invalid ~ label {
    color: red;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  .claim-product-heading {
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
    margin-bottom: 2rem;
  }
  .claim-product-text {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #c6c5c5;
  }
  .secondary-color {
    color: #c6c5c5;
  }
  .claim-product-img {
    width: 115px;
    height: 82px;
    border-radius: 10px;
    border: solid 2px #ffffff;
    margin-right: 6px;
  }
  @media (max-width:550px) {
    .claim-product-img {
      max-width: 80px !important;
    }
  }
  @media (max-width:495px) {
    .claim-product-heading {
      margin-bottom: 0rem;
      font-size: 1.1rem;
    }
    .claim-product-img {
      height: 70px;
    }
  }
  .claim-doc-icon p {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #4c505d;
  }
  .claim-data-icon img {
    margin: 0 auto;
    width: 45%;
    height: auto;
  }
  .claim-data-icon:hover + .remove-doc-icon {
    display: block;
  }
  .jbl-nav-tabs .nav-link, .nav-link {
    color: #5b6770;
  }
  .data-row-item:hover, .data-row-item:active, .data-row-item:focus {
    border: solid 2px #3d9cbd;
    cursor: pointer;
  }
  .data-row-item {
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    border: solid 2px #fff;
    background-color: #ffffff;
    margin-left: 0 !important;
  }
  .jbl-modal-body .data-row-item {
    margin-bottom: 17px;
  }
  table > tbody > tr, .data-row {
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #dedada;
    background-color: #ffffff;
    margin: 10px auto;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-sub-heading{
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
    margin-bottom: 14px;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Avenir Medium";
  }
  .data-row .claim-row-data {
    font-family: "Avenir Medium";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .data-row .claim-row-heading {
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img, .data-row .data-img img {
    width: 74px;
    height: 48px;
    border-radius: 7px;
  }
  .modal-dialog-scrollable .modal-body.jbl-modal-body {
    overflow-y: auto;
    max-height: 640px;
  }
  .jbl-plc-change span {
    width: 15%;
  }
  @media (min-width:769px) {
    .jbl-plc-change {
      position:relative;
    }
    .jbl-plc-change span {
      position: absolute;
      right: -64px;
      width: 8%;
      bottom: 3.8rem;
      cursor: pointer;
    }
  }
  @media (max-width:768px) {
    .jbl-plc-change span {
      margin-bottom: 1rem;
    }
  }
  .claim_modal_type_heading {
    margin: 20px 0px 0px;
    font-family: "Avenir Medium";
    font-size: 20px;
    /* font-weight: 900; */
    text-align: left;
    color: #039fcb;
  }
  .modal-dialog {
    max-width: 600px !important;
  }
  .edit-btn-position {
    position: relative;
    bottom: 94px;
    right: 15px;
  }
  .in-min-width{
    width: 115px;
    height: auto;
  }
  @media(max-width:550px){
    .edit-btn-position {
      position: relative;
      bottom: 44px;
      right: 10px;
    }
    .in-min-width{
      width: 65px;
      height: 65px;
    }
  }
  .ib-btn-primary {
    min-height: 47px !important;
    position: relative !important;
    top: 1px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Complaint/Create.vue